<template lang="pug">
.card.terms-and-conditions(:class="{'card--expand': isProgressState, 'card--done': isFinishedState}")
    .loader-content(v-if="isLoading" class="loader-content__terms-and-conditions z-999")
      cp-loader(text="Aguarde estamos processando")

    .msg-error(v-if="errorMsg" class="z-999")
      img.msg-error__icon(src='@/assets/icons/warning.svg')
      span {{ errorMsg }}

    .card__head
      .titleStep
        cp-icon.titleStep__icon(v-if="!hasMobile" :path="`/icons/documents${!isFinishedState ? '-off' : ''}.svg`")
        h3.titleStep__title Termos  e condições

      .btnEdit(v-if="isFinishedState && !hasMobile" @click="openStep")
        img.btnEdit__icon(src='@/assets/icons/edit.svg')
        span.btnEdit__label Editar

    .card__body.terms-and-conditions__container(:class="expandContent")

      .terms-and-conditions__wrapper
        .terms-and-conditions__methods
          cp-terms-accept(@acceptedTerms="getAcceptedTerms")

          .terms-and-conditions__row
            cp-button.terms-and-conditions__btn(
              size="medium"
              label="Concluir"
              :disabled="isAcceptedTerms"
              @onClick="requestPlanCreation"
            )
</template>
<script>
import { mapState, mapActions } from 'vuex'

import views from '@/mixins/views'
import dataLayer from '@/utils/data-layer'
import { PROGRESS_STATE, FINISHED_STATE } from '@/stateSteps'

import cpAlert from '@/components/atoms/Alert.vue'
import cpButton from '@/components/atoms/Button.vue'
import cpField from '@/components/molecules/Field.vue'
import cpIcon from '@/components/atoms/Icon.vue'
import cpLoader from '@/components/molecules/Loader.vue'

import cpTermsAccept from '@/components/atoms/TermsAccept.vue'

export default {
  name: 'TermsAndConditions',
  mixins: [views],
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      hasMobile: '',
      errorMsg: '',
      isAcceptedTerms: true
    }
  },
  components: {
    cpAlert,
    cpButton,
    cpField,
    cpIcon,
    cpLoader,
    cpTermsAccept
  },
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  watch: {
    errorMsg (newValue) {
      newValue && this.errorMsg && setTimeout(() => { this.errorMsg = '' }, 7000)
    }
  },
  computed: {
    ...mapState([
      'product',
      'steps',
      'personalData',
      'plan'
    ]),
    expandContent () {
      return {
        'terms-and-conditions__container--expand': this.steps.sendQuotation === PROGRESS_STATE || this.hasMobile
      }
    },
    isProgressState () {
      return this.steps.sendQuotation === PROGRESS_STATE || this.hasMobile
    },
    isFinishedState () {
      return this.steps.sendQuotation === FINISHED_STATE
    }
  },
  methods: {
    ...mapActions('sendQuotation', ['postQuotation']),
    ...mapActions('payment', ['createPlan']),
    async requestPlanCreation () {
      if (!navigator.onLine) {
        this.errorMsg = 'Você está off-line. Verifique sua conexão.'
        return false
      }

      try {
        this.isLoading = true
        this.setDataLayer('attempted')
        // this.changeAcceptedConditions(this.listOfAcceptedConditions)

        const { data } = await this.createPlan()

        this.planSuccessfullyCreated(data)
      } catch (error) {
        console.error(error)
        this.$sentry.logWithContext({
          level: 'error',
          tags: {
            app_product: this.product.alias,
            app_step: 'TermsAndConditions',
            app_errorZone: 'requestPlanCreation'
          },
          ctx: {
            label: '[TermsAndConditions] - requestPlanCreation'
          },
          error
        })

        const apiErrorMessage =
          error.response?.data?.message ||
          (error.response?.data?.errorDetails && error.response?.data?.errorDetails[0]?.message)

        if (apiErrorMessage) {
          this.setDataLayer('inputError')

          if (apiErrorMessage === this.msgPlanExist) {
            window.location.replace(`${this.product.redirectError}`)
            return false
          }

          this.errorMsg = apiErrorMessage
        } else {
          this.setDataLayer('systemError')
          this.errorMsg = 'Não foi possível processar o seu pagamento. Confira os dados e tente novamente mais tarde.'
        }

        this.isLoading = false
      }
    },
    async planSuccessfullyCreated (data) {
      try {
        if (data.uuid) {
          this.setDataLayer('success')

          const dl = {
            event: `ecommerce-${this.product.alias}`,
            parcelas: 1,
            meiopagamento: '',
            cupom: '',
            sku: this.plan.uuid,
            name: `${this.plan.category} - ${this.plan.planType}`,
            category: 'Saúde Protegida',
            price: this.plan.value,
            quantity: 1,
            transactionId: data.uuid,
            transactionAffiliation: 'semprebem',
            transactionTotal: this.plan.precoTotal,
            transactionTax: '0',
            transactionShipping: '0'
          }

          window.dataLayer.push(dl)

          this.nextStep()
        }
      } catch (error) {
        console.error(error)
        this.$sentry.logWithContext({
          level: 'error',
          tags: {
            app_product: this.product.alias,
            app_step: 'TermsAndConditions',
            app_errorZone: 'planSuccessfullyCreated'
          },
          ctx: {
            label: '[TermsAndConditions] - planSuccessfullyCreated'
          },
          error
        })

        this.setDataLayer('systemError')
        this.errorMsg = 'Não foi possível processar seu pedido. Confira os dados e tente novamente mais tarde.'

        this.isLoading = false
      }
    },
    openStep () {
      this.steps.personalData = FINISHED_STATE
      this.steps.address = FINISHED_STATE
      this.steps.sendQuotation = PROGRESS_STATE

      this.$router.push({ name: 'TermsAndConditions' })
    },
    handleResize () {
      this.hasMobile = window.innerWidth <= 767
    },
    setDataLayer (type) {
      const metricsList = {
        attempted: {
          event: `${this.product.alias}-semprebem`,
          category: `${this.product.alias}-envio-dados`,
          action: 'click',
          label: 'tentativa'
        },
        success: {
          event: `${this.product.alias}-semprebem`,
          category: `${this.product.alias}-envio-dados`,
          action: 'click',
          label: 'proteger-agora'
        },
        systemError: {
          event: `${this.product.alias}-semprebem`,
          category: 'error-envio-dados',
          action: 'erro',
          label: 'erro do sistema'
        },
        inputError: {
          event: `${this.product.alias}-semprebem`,
          category: 'error-envio-dados',
          action: 'click',
          label: 'erro de input'
        }
      }

      dataLayer(metricsList[type])
    },
    getAcceptedTerms (value) {
      this.isAcceptedTerms = value
    },
    nextStep () {
      // Adicionando um delay para métrica de e-commerce contabilizar no GTM
      setTimeout(() => {
        this.$router.push({ name: 'success' })
      }, 1000)
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .terms-and-conditions {
    &__container {
      display: none;

      &--expand {
        display: block;
      }
    }

    &__row {
      position: relative;
      width: 100%;

      @media screen and (min-width: 768px) {
        display: flex;
        justify-content: flex-start;
      }
    }

    &__btn {
      margin-top: 32px;
      max-width: 180px;
    }

    &__wrapper {
      position: relative;
    }

    &__methods ~ * {
      margin-top: 48px;
    }

    .alert + * {
      margin-top: 16px;
    }
  }

  .msg-error {
    background-color: rgba(255, 59, 48, 1);
    display: flex;
    height: auto;
    justify-content: center;
    left: 0;
    top: 0;
    padding: 16px;
    position: fixed;
    width: 100%;

    &__icon {
      margin-right: 16px;
      width: 20px;
    }

    span {
      font-weight: 500;
      font-size: 16px;
      font-family: $rubik-font-family;
      color: #fff;

      @media screen and (max-width: 767px) {
        font-size: 14px;
      }
    }

    @at-root {
      .header ~ .hiring-step .msg-error {
        top: 76px;

        @media screen and (max-width: 767px) {
          top: 56px;
        }
      }
    }
  }

  .loader-content {
    align-items: center;
    background-color: rgba(#fff, .95);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;

    &__terms-and-conditions {
      position: fixed;
    }
  }
</style>
